<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Sidebar from '@/Shared/Sidebar/SidebarBannersNews.vue'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  brandInfo: Array,
  pref: Object,
})

const cleanup = (str) => {
  const t = stripslashes(str)
  return replaceS3path(t).replace(/&nbsp;/g, '')
}

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="story-detail">
    <Head :title="props.brandInfo[0].akimamaTitle " />

    <template v-if="props.brandInfo.length >= 1">
      <div class="detail-container">
        <Breadcrumbs category="story" :title="props.brandInfo[0].akimamaTitle" />

        <div class="detail-contents">
          <div class="main">
            <img :src="replaceS3path(props.brandInfo[0].akimamaThumb)" :alt="props.brandInfo[0].akimamaTitle" />
            <div class="main-contents">
              <h1>{{ props.brandInfo[0].akimamaTitle }}</h1>
              <div class="lead" v-html="cleanup(props.brandInfo[0].akimamaLead)" />
              <div v-html="cleanup(props.brandInfo[0].akimamaTxt)" />
            </div>
          </div>

          <Sidebar category="brands" :slug="props.brandInfo[0].akimamaRelBrand" />
        </div>
      </div>
    </template>
    <template v-else>not found</template>
  </div>
</template>
